import { OgpApiService } from './ogp-api-service';
import {
  ServiceAgreementFilterPayload,
  ServiceAgreementsResponse,
} from './service-agreements.types';

export class ServiceAgreementsService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getServiceAgreementsForCompany = async (relation?: ServiceAgreementFilterPayload) => {
    return await this.ogpApiService.get<ServiceAgreementsResponse>({
      path: 'service-agreements',
      params: {
        isLender: relation?.isLender,
        isBorrower: relation?.isBorrower,
      },
    });
  };
}
